import { MdClose } from "react-icons/md";

import { MobileLogo } from "../Logo/MobileLogo";

export interface MobileNavOverlayProps {
  open: boolean;
  onClose: () => void;
  children?: React.ReactNode;
}

export const MobileNavOverlay = ({
  open,
  onClose,
  children,
}: MobileNavOverlayProps) => {
  if (!open) return null;

  const handleNavClick = (event: React.MouseEvent<HTMLElement>) => {
    if ((event.target as HTMLElement).closest("a")) {
      onClose();
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex flex-col bg-surface">
      <div className="container mx-auto flex h-20 items-center gap-4 px-4 sm:px-0">
        <MobileLogo />
        <button
          type="button"
          aria-label="Close menu"
          onClick={onClose}
          className="cursor-pointer text-accent-primary"
        >
          <MdClose size={32} />
        </button>
      </div>

      <nav
        className="container m-auto flex flex-col gap-9 px-4 pb-20 sm:px-0"
        onClick={handleNavClick}
      >
        {children}
      </nav>
    </div>
  );
};

